import Nav from '../components/shared/Nav';
import Footer from '../components/shared/Footer';
import PRHero from '../components/pixrow/PRHero';
import PRStatsBand from '../components/pixrow/PRStatsBand';
import PRPipeline from '../components/pixrow/PRPipeline';
import PRPixViewerLink from '../components/pixrow/PRPixViewerLink';

export default function PixRowPage() {
  return (
    <div data-screen-label="03 PixRow">
      <Nav current="pixrow" />
      <PRHero />
      <PRStatsBand />
      <PRPipeline />
      <PRPixViewerLink />
      <Footer />
    </div>
  );
}
